import { useState } from 'react';
import type { DatovkaApiType, DatovkyApiSeznam } from '@gov-nx/api';
import {
	searchDataBoxesQuery,
	useAxiosInstance,
	usePoMutation,
	usePoQuery,
} from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';

export const useDataBoxSearchAutocomplete = (
	typeSearch: 'GENERAL',
	dataBoxType?: DatovkaApiType['typSchranky']
) => {
	const [text, setText] = useState<Optional<string>>(undefined);
	const { axiosInstance } = useAxiosInstance();

	const mainQuery = usePoQuery<DatovkyApiSeznam>({
		queryKey: ['data-box-autocomplete', typeSearch, dataBoxType, text],
		queryFn: () =>
			searchDataBoxesQuery(
				axiosInstance,
				text as string,
				typeSearch,
				dataBoxType
			),
		enabled: text ? text?.length > 2 : false,
		retry: 0,
		refetchOnWindowFocus: false,
	});

	const mutation = usePoMutation({
		mutationFn: (value: string) =>
			searchDataBoxesQuery(axiosInstance, value, typeSearch, dataBoxType),
	});

	return {
		isFetching: mainQuery.isFetching,
		isLoading: mainQuery.isLoading,
		dataBoxes: mainQuery.data?.seznam ?? [],
		setText,
		searchCallback: async (value: string): Promise<DatovkaApiType[]> => {
			const result = await mutation.mutateAsync(value);
			return result.seznam ?? [];
		},
	};
};
